// extracted by mini-css-extract-plugin
export default {"mainWrapper":"mainComponentStyles_mainWrapper__k0IYf","mainWrapperSlide":"mainComponentStyles_mainWrapperSlide__oH9Pf"};